import loaiTrangThai from './danh-muc-dung-chung/loai-trang-thai/mutations'

export default {
  ...loaiTrangThai,
}
